import Channel from '../../classes/channel';
import Content from '../../types/enums/content';
import Rail from '../../classes/rail';
import TranslationManager from '../../assets/locale/translationsManager';
import { RailDisplayMode, RailType } from '../../types/enums/rail';

function generateChannelsRailsWithData(channels: Channel[], title?: string) {
  const channelsBase = {
    section: {
      title: title
        ? TranslationManager.get('MISC.CHANNELS') + ' ' + title
        : TranslationManager.get('COMPONENTS.RAILS.TITLE.CHANNELS'),
      presentationType: RailDisplayMode.SQUARE,
      name: 'channelRail',
    },
  };
  const nowOnTvBase = {
    section: {
      title: TranslationManager.get('COMPONENTS.RAILS.TITLE.NOW_ON_TV'),
      presentationType: RailDisplayMode.PHOTO,
      name: 'channelRail',
    },
  };
  const data = channels
    ?.filter(
      (channel) =>
        channel.type !== Content.AVOD && channel.type !== Content.SVOD
    )
    ?.map(
      (item) => item?.getCurrentEvent() || item?.getMockedEvent() || undefined
    )
    ?.filter((item) => {
      return item;
    });
  const channelsRail = Rail.constructorWithData(
    channelsBase,
    data || [],
    RailType.CHANNEL
  );
  const nowOnTvRail = Rail.constructorWithData(
    nowOnTvBase,
    data || [],
    RailType.EPG
  );
  return [channelsRail, nowOnTvRail];
}

export default generateChannelsRailsWithData;
